const FeedbackTab = ({ feedback }) => {
  if (!feedback) return null

  return (
    <div className="overflow-x-auto">
      <h3 className="text-xl font-semibold text-white mb-6">
        Feedback Submissions ({feedback.length})
      </h3>
      <table className="min-w-full divide-y divide-white/10">
        <thead>
          <tr>
            {['Facilitator', 'Email', 'Impact', 'Curation', 'Future', 'Memorable Part', 'Improvements', 'Date'].map(header => (
              <th key={header} className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/10">
          {feedback.map((item) => (
            <tr key={item.id} className="hover:bg-white/5">
              <td className="px-4 py-4 whitespace-nowrap text-sm font-medium text-white">
                {item.facilitatorName}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.facilitatorEmail}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.feedbackData.impactRating}/10
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.feedbackData.curationQualityRating}/10
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {item.feedbackData.futureLikelihood}/10
              </td>
              <td className="px-4 py-4 text-sm text-gray-300 max-w-xs truncate">
                {item.feedbackData.memorablePart || 'N/A'}
              </td>
              <td className="px-4 py-4 text-sm text-gray-300 max-w-xs truncate">
                {item.feedbackData.improvementSuggestions || 'N/A'}
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-300">
                {new Date(item.createdAt).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default FeedbackTab
